import { useQuery } from '@tanstack/react-query';
import useGlynt from '../useGlynt';

interface UseDocumentDataListParams {
  documentId?: string;
  enabled?: boolean;
}

export const useDocumentDataList = ({ documentId, enabled = true }: UseDocumentDataListParams) => {
  const glynt = useGlynt();

  return useQuery({
    queryKey: ['documentData', documentId],

    queryFn: async () => {
      const response = await (await glynt).documentData.list({ document: documentId });
      return response;
    },

    enabled: enabled && !!documentId
  });
};
